import { memo } from "react"
import { IconCaretDownFill18 as CaretIcon } from "nucleo-ui-fill-18"

import { cn } from "@productlane/lib/src/browser"

/** Same h-7 box in the rail and the hover panel, so no row shifts when the sidebar expands. */
export const SECTION_HEADER_BOX = "flex h-7 flex-none items-center"

export const SidebarSectionHeader = memo(
	({
		label,
		collapsed,
		folded,
		onToggle,
	}: {
		label: string
		collapsed: boolean
		folded: boolean
		onToggle: () => void
	}) => {
		if (collapsed) {
			return (
				<div
					aria-hidden
					data-testid="sidebar-section-header"
					className={cn(SECTION_HEADER_BOX, "justify-center")}
				>
					<span className="h-px w-4 bg-gray-200 dark:bg-gray-700/80" />
				</div>
			)
		}

		return (
			<button
				type="button"
				data-testid="sidebar-section-header"
				aria-expanded={!folded}
				onClick={onToggle}
				className={cn(
					SECTION_HEADER_BOX,
					"w-fit cursor-default select-none gap-1 rounded-md pl-2 pr-1.5 text-xs font-medium text-tertiary hover:text-secondary",
				)}
			>
				{label}
				<CaretIcon
					className={cn(
						"h-2.5 w-2.5 flex-none transform-gpu",
						folded && "-rotate-90",
					)}
				/>
			</button>
		)
	},
)
